"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatBannerCommon = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _gemUrlFormatUtils = require("../common/utils/domain/gemUrlFormatUtils");
var _urlUtils = require("../common/utils/domain/urlUtils");
var _formatCommodityData = require("./formatCommodityData");
const _excluded = ["href"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const formatBannerCommon = (properties, options = {}) => {
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const postMessageUrl = (0, _urlUtils.getVideoIframeUrl)(options);
  const _ref = properties || {},
    content = _ref.content,
    _ref$buttonList = _ref.buttonList,
    buttonList = _ref$buttonList === void 0 ? [] : _ref$buttonList,
    _ref$tabList = _ref.tabList,
    tabList = _ref$tabList === void 0 ? [] : _ref$tabList;
  const resultList = (buttonList || []).map((bannerBtnItem, index) => {
    const _bannerBtnItem$commod = bannerBtnItem.commodityObject,
      commodityObject = _bannerBtnItem$commod === void 0 ? '{}' : _bannerBtnItem$commod,
      _bannerBtnItem$href = bannerBtnItem.href,
      href = _bannerBtnItem$href === void 0 ? '' : _bannerBtnItem$href;
    const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
    const formattedHref = formatUrlString(href);
    console.log('formatBannerCommon--', formattedHref, href);
    const item = _objectSpread(_objectSpread(_objectSpread({}, bannerBtnItem), {}, {
      href: formattedHref
    }, resultCommodityObject), {}, {
      extendProps: {
        'report-event': 'click_banner_button',
        'report-ext1': index,
        'report-ext2': bannerBtnItem.label,
        'report-ext3': formattedHref
      },
      postMessageUrl
    });
    return item;
  });
  const handledTabList = tabList === null || tabList === void 0 ? void 0 : tabList.map(tabItem => {
    const _ref2 = tabItem || {},
      href = _ref2.href,
      others = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
    return _objectSpread(_objectSpread({}, others), {}, {
      href: formatUrlString(href)
    });
  });
  return _objectSpread(_objectSpread({}, properties), {}, {
    buttonList: resultList,
    tabList: handledTabList,
    content: formatUrlInText(content)
  });
};
exports.formatBannerCommon = formatBannerCommon;